import React, { useEffect, useState } from "react";
import Navbar from "./Components/Navbar";
import { Hero } from "./Components/Hero";
import Background from "./Components/Background";

function App() {
  const [isDark, setIsDark] = useState(() => {
    const savedTheme = localStorage.getItem("theme");
    return savedTheme ? savedTheme === "dark" : true;
  });

  useEffect(() => {
    const root = document.documentElement;

    if (isDark) {
      root.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      root.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  }, [isDark]);

  return (
    <div>
      <Background />
      <Navbar isDark={isDark} setIsDark={setIsDark} />
      <Hero />
    </div>
  );
}

export default App;
